import { render } from "./index.vue?vue&type=template&id=7cb5f89c&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=7cb5f89c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb5f89c"]])

export default __exports__